import { AppViewport, AppContainer } from '@/components/layout'
import { RequestState } from '@/components/ui/RequestState'
import { useEffect, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useProfileQuery } from '@/hooks/api/queries'
import { clearAnonymousAccountCache } from '@/lib/auth/session'
import Splash from '@/components/Splash'
import { AuthContext } from './AuthContext'

export function AuthProvider({ children }: { children: ReactNode }) {
  const client = useQueryClient()
  const profile = useProfileQuery()
  const user = profile.data ?? null
  useEffect(() => {
    if (profile.data === null) clearAnonymousAccountCache(client)
  }, [profile.data, client])
  const isAuthChecking = profile.isPending
  return <AuthContext.Provider value={{ user, isAuthenticated: Boolean(user), isAuthChecking }}>
    {isAuthChecking ? <Splash /> : profile.isError && !user ? <AppViewport><AppContainer><RequestState kind="error" title="بررسی ورود انجام نشد. دوباره تلاش کنید." onRetry={() => { void profile.refetch() }} /></AppContainer></AppViewport> : children}
  </AuthContext.Provider>
}
